export default __webpack_public_path__ + "static/media/4.93ff78f2.jpg";